<div
  class="palantir-input"
  [ngClass]="{
    'palantir-input--with-prefix': prefix,
    'palantir-input--with-suffix': suffix,
  }"
>
  @if (label) {
    <palantir-text class="palantir-input__label" type="description">
      {{ label }}
      {{ isRequired() ? '*' : '' }}
    </palantir-text>
  }

  <ng-content select="[palantir-input-label], palantir-input-label" />

  <div class="palantir-input__container">
    @if (prefix) {
      <palantir-icon class="palantir-input__prefix" [name]="prefix" />
    }

    <ng-content />

    @if (suffix) {
      <palantir-icon class="palantir-input__suffix" [name]="suffix" />
    }
  </div>

  <div class="palantir-input__meta">
    <ng-content select="[palantir-input-error], palantir-input-error" />

    @if (maxLength()) {
      <palantir-text size="xs" class="palantir-input__max-length" type="description"
        >{{ inputLength() }} / {{ maxLength() }}</palantir-text
      >
    }
  </div>
</div>
